import { getUser } from '@utsubo/experience'

import { adminsUid } from '@/datas/admins'

export const isAdmin = (uid = null) => {
  const { user, id } = getUser()
  return (
    adminsUid.includes(uid ? uid : id) ||
    (user && user.email && user.email.endsWith('@utsubo.co'))
  )
}
